import React from 'react';
import { FaReact, FaCoffee, FaHeart} from "react-icons/fa";
import { 
  Box, 
  Text, 
  Link, 
  VStack, 
  HStack,
  Button,
  Divider,
  Icon,
  Container
} from "@chakra-ui/react";

const Footer = () => {
  return (
    <Box 
      bg="gray.900" 
      borderTop="1px solid"
    >
      <Container maxW="1200px" py={8} px={4}>
        <VStack spacing={6}>
          
          {/* Main Message */}
          <VStack spacing={3} textAlign="center" maxW="700px">
            <Text 
              fontSize={{ base: "md", md: "lg" }} 
              fontWeight="semibold"
              bgGradient="linear(to-r, teal.300, blue.400)"
              bgClip="text"
            >
              Built with love for Mattias 💙
            </Text>
            <Text fontSize="sm" color="gray.400" lineHeight="tall">
              This project helps track what matters most for Mattias' future.
              Your support goes directly into his long-term investment fund 📈👶
            </Text>
          </VStack>

          {/* Support Buttons */}
          <HStack 
            spacing={4} 
            flexWrap="wrap" 
            justify="center"
          >
            <Button
              as={Link}
              href="https://paypal.me/angelindga"
              isExternal
              leftIcon={<FaCoffee />}
              colorScheme="teal"
              variant="solid"
              size="md"
              _hover={{ 
                transform: "translateY(-2px)",
                boxShadow: "lg",
                textDecoration: "none"
              }}
              transition="all 0.2s"
            >
              Buy a Coffee ☕
            </Button>
            
            <Button
              as={Link}
              href="https://revolut.me/angelin_dan"
              isExternal
              leftIcon={<FaHeart />}
              colorScheme="pink"
              variant="solid"
              size="md"
              _hover={{ 
                transform: "translateY(-2px)",
                boxShadow: "lg",
                textDecoration: "none"
              }}
              transition="all 0.2s"
            >
              Support on Revolut
            </Button>
          </HStack>

          <Divider borderColor="gray.800" />

          {/* Creator & Tech Stack */}
          <VStack spacing={2}>
            <HStack spacing={2} fontSize="sm" color="gray.400">
              <Text>Crafted with</Text>
              <Icon as={FaHeart} color="red.400" boxSize={3} />
              <Text>by</Text>
              <Link 
                href="https://dan-angelin.com/" 
                isExternal 
                fontWeight="bold" 
                color="teal.300"
                _hover={{ color: "teal.200" }}
              >
                Dan Angelin
              </Link>
            </HStack>
            
            <HStack spacing={2} fontSize="xs" color="gray.500">
              <Text>&copy; {new Date().getFullYear()} Mattias Assets</Text>
              <Text>•</Text>
              <HStack spacing={1}>
                <Text>Built with</Text>
                <Icon as={FaReact} color="cyan.400" />
                <Text>React</Text>
              </HStack>
            </HStack>
          </VStack>

        </VStack>
      </Container>
    </Box>
  );
};

export default Footer;